import { SessionStorage } from 'quasar'
// import { showErrorMessage } from 'src/functions/function-show-error-message'

const state = {
  // getAuthLoggedIn: false
}

const mutations = {}

const actions = {
  getAllSession () {
    const sessions = SessionStorage.getAll()
    // eslint-disable-next-line no-console
    console.log('Session: ', sessions)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
